import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';
import { IBaseInstrument, IInstrument } from '../sp-types/instrumentType';
import { getItem } from './genericFB';

const INSTRUMENTS_COLLECTION_NAME = 'instruments';
const BASE_INSTRUMENTS_COLLECTION_NAME = 'base-instruments';
const DB_LOCATION = db;

export async function createBaseInstrument(
  data: IBaseInstrument,
  baseInstrumentId: string,
  callback?: (success: boolean, createdObject?: IBaseInstrument) => void,
) {
  try {
    const docRef = doc(DB_LOCATION, BASE_INSTRUMENTS_COLLECTION_NAME, baseInstrumentId);
    await setDoc(docRef, data);
    const docSnap = await getDoc(docRef);
    const baseInstrument = docSnap.data() as IBaseInstrument;
    baseInstrument.id = docSnap.id;
    return baseInstrument;
  } catch (err) {
    console.log(`Error creating balance flow: ${err}`);
    callback && callback(false);
  }
}

export async function getBaseInstrumentsByIds(baseInstrumentIds: string[]): Promise<IBaseInstrument[]> {
  try {
    const baseInstruments: IBaseInstrument[] = [];
    for (const baseInstrumentId of baseInstrumentIds) {
      const docRef = doc(DB_LOCATION, BASE_INSTRUMENTS_COLLECTION_NAME, baseInstrumentId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const baseInstrument = docSnap.data() as IBaseInstrument;
        baseInstrument.id = docSnap.id;
        baseInstruments.push(baseInstrument);
      }
    }
    return baseInstruments;
  } catch (err) {
    console.log(`Error getting routes by IDs: ${err}`);
    return [];
  }
}

export async function createInstrument(
  data: IInstrument,
  instrumentId: string,
  callback?: (success: boolean, createdObject?: IInstrument) => void,
) {
  try {
    const docRef = doc(DB_LOCATION, INSTRUMENTS_COLLECTION_NAME, instrumentId);
    await setDoc(docRef, data);
    const docSnap = await getDoc(docRef);
    const instrument = docSnap.data() as IInstrument;
    instrument.id = docSnap.id;
    return instrument;
  } catch (err) {
    console.log(`Error creating balance flow: ${err}`);
    callback && callback(false);
  }
}

export async function getInstrumentsByIds(instrumentIds: string[]): Promise<IInstrument[]> {
  try {
    const instruments: IInstrument[] = [];
    for (const instrumentId of instrumentIds) {
      const docRef = doc(DB_LOCATION, INSTRUMENTS_COLLECTION_NAME, instrumentId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const instrument = docSnap.data() as IInstrument;
        instrument.id = docSnap.id;
        instruments.push(instrument);
      }
    }
    return instruments;
  } catch (err) {
    console.log(`Error getting routes by IDs: ${err}`);
    return [];
  }
}

export async function getInstrumentById(instrumentId: string): Promise<IInstrument | null> {
  return getItem<IInstrument>(instrumentId, INSTRUMENTS_COLLECTION_NAME);
}
